import React, { useState } from "react";
import axios from "axios";

function App() {
  const [text, setText] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handlePredict = async () => {
    setLoading(true);
    setResult(null);
    setStatus("");

    const controller = new AbortController();

    // Show “warming up” only if the backend takes >3s to respond
    const warmupTimer = setTimeout(() => {
      setStatus("Warming up the server... this may take 30–60 seconds ⏳");
    }, 3000);

    try {
      const timeout = setTimeout(() => controller.abort(), 45000); // 45s hard timeout

      const res = await axios.post(
        "https://nlp-deployments.onrender.com/predict",
        { text },
        { signal: controller.signal }
      );

      clearTimeout(warmupTimer);
      clearTimeout(timeout);
      setStatus("");
      setResult(res.data.prediction === 1 ? "Sarcastic 😏" : "Not Sarcastic 🙂");
    } catch (err) {
      clearTimeout(warmupTimer);
      console.error(err);
      if (err.name === "CanceledError") {
        setStatus("Server is still waking up... please try again in a few seconds 💤");
      } else {
        setStatus("Error connecting to backend. Try again soon.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "5rem" }}>
      <h2>Sarcasm Classifier</h2>
      <textarea
        rows="4"
        cols="50"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Type a sentence..."
        disabled={loading}
      />
      <br />
      <button onClick={handlePredict} disabled={loading || !text.trim()}>
        {loading ? "Predicting..." : "Predict"}
      </button>

      {status && <p>{status}</p>}
      {result && <h3>Result: {result}</h3>}
    </div>
  );
}

export default App;
